import { useMemo } from "react";

const useDynamicFilter = (data, searchTerm) => {
  return useMemo(() => {
    if (!searchTerm) return data;

    const isAssignee = data[0]?.hasOwnProperty("first_name");
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    return data.filter((item) => {
      if (isAssignee) {
        const fullName = `${item.first_name} ${item.last_name}`.toLowerCase();
        return fullName.includes(lowerCaseSearchTerm);
      } else {
        return item.name?.toLowerCase().includes(lowerCaseSearchTerm);
      }
    });
  }, [data, searchTerm]);
};

export default useDynamicFilter;
